import axios from "axios";

type ActivityPayload = {
  module: string;
  action: string;
  description?: string;
};

const trackActivity = async (payload: ActivityPayload) => {
  // 🚫 LOOP PREVENTION
  // Never log logs about logs
  if (
    payload.module === "LOGS" || 
    payload.module === "AUDIT" || 
    payload.description?.includes("/logs")
  ) {
    return;
  }

  try {
    // Axios defaults (baseURL, Authorization) are managed by AuthContext
    await axios.post("/system-settings/logs/activity", payload);
  } catch (error) {
    // ❗ NEVER throw
    // We swallow the error to ensure UI never breaks
    if (process.env.NODE_ENV === 'development') {
        console.warn("Activity log failed:", payload, error);
    }
  }
};

export default trackActivity;
